// forms — [для 1, для 2-4, для 5-0]: ["заказ", "заказа", "заказов"]
export const pluralForm = (count: number, forms: string[]): string => {
  const tens = Math.abs(count) % 100
  const units = tens % 10

  if (tens > 10 && tens < 20) return forms[2]
  if (units === 1) return forms[0]
  if (units > 1 && units < 5) return forms[1]
  return forms[2]
}

export const pluralize = (count: number, forms: string[]): string =>
  `${count} ${pluralForm(count, forms)}`
